import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {CoreRoutingModule} from './core-routing.module';
import {LandingComponent} from './landing/landing.component';
import {FlexModule} from "@angular/flex-layout";
import {NzLayoutModule} from "ng-zorro-antd/layout";
import {NzButtonModule} from "ng-zorro-antd/button";
import {NzImageModule} from "ng-zorro-antd/image";
import {NzSpinModule} from "ng-zorro-antd/spin";
import {ErrorInterceptor} from "./interceptors/error.interceptor";
import {LoadingInterceptor} from "./interceptors/loading.interceptor";
import {HTTP_INTERCEPTORS} from "@angular/common/http";
import {NzMessageModule} from "ng-zorro-antd/message";

/**
 * Includes a single component called LandingComponent.
 */
@NgModule({
    declarations: [
        LandingComponent
    ],
    exports: [],
    imports: [
        CommonModule,
        CoreRoutingModule,
        FlexModule,
        NzLayoutModule,
        NzButtonModule,
        NzImageModule,
        NzSpinModule,
        NzMessageModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LoadingInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorInterceptor,
            multi: true
        }
        ],
})
export class CoreModule {
}
